
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[zone]",
      function () {
        return require("private-next-pages/[zone]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[zone]"])
      });
    }
  